module.exports = __webpack_public_path__ + "img/feedback.01a55c1c.png";